import {KeyLabel} from './key-label.model';

export class Feed {
  url: string;
  title: string;
  description: string;
  category: string;
  source: FeedSource;
  feedTypeYT: FeedTypeYT;
  playlistIds: string[];
  newPlaylist: boolean;
  newPlaylistName?: string;
  ownerType?: OwnerType;
  coId?: string;
  ownerId?: string;
  count?: number;
  categories: string[];
  thumbnailFile?: string;
  dateFrom?: Date;
}

export enum FeedTypeYT {
  PLAYLIST = 'PLAYLIST',
  VIDEO = 'VIDEO',
  CHANNEL = 'CHANNEL',
  TRILLER = 'TRILLER',
}

export const FeedTypeLabels = {
  PLAYLIST: 'Playlist',
  VIDEO: 'Video',
  CHANNEL: 'Channel',
  TRILLER: 'Triller',
};

export const FeedTypeKL = () =>
  (Object.keys(FeedTypeYT).map(key => new KeyLabel(<FeedTypeYT> key, FeedTypeLabels[key])));

export enum FeedSource {
  YOUTUBE = 'YOUTUBE',
  UPLOAD = 'UPLOAD',
  RSS = 'RSS'
}

export const FeedSourceLabels = {
  YOUTUBE: 'YouTube',
  UPLOAD: 'Upload',
  RSS: 'RSS/MRSS'
};

export const FeedSourceKL = () =>
  (Object.keys(FeedSource).map(key => new KeyLabel(<FeedSource> key, FeedSourceLabels[key])));

export class FeedCategoriesYT {
  id: string;
  title: string;
}

export enum OwnerType {
  VB = 'VB',
  PUBLISHER = 'PUBLISHER',
  CONTENT_OWNER = 'CONTENT_OWNER'
}

export const OwnerTypeLabels = {
  VB: 'Videobyte',
  PUBLISHER: 'Publisher',
  CONTENT_OWNER: 'Content owner'
};

export const OwnerTypeKL = () =>
  (Object.keys(OwnerType).map(key => new KeyLabel(key as OwnerType, OwnerTypeLabels[key])));
